<div *ngIf="screenSize?.mobile && (setHeaderStyle?.active || activeCustom)" class="line" [ngStyle]="{'background-color': (setHeaderStyle?.active || activeCustom) ? configStylesHeader?.header_secondary_color : null }"></div>
<header class="container-fluid header" id="header" [ngClass]="{'christmas': christmas}"
[ngStyle]="{
  'background-color' :  bgColor,
  'background-image': bgImageUrl}">
  <div class="flex flex-wrap cont-items" [ngStyle]="{'background-color':bgColor,'background-image': bgImageUrl}">

    <div class="col-3 cont-menu-icon d-flex d-md-none ">
      <a [routerLink]="['/cuenta']">
        <img class="img-menu" [src]="((setHeaderStyle?.active || activeCustom) && configStylesHeader?.header_user_icon) ? configStylesHeader?.header_user_icon :  'assets/svg/icon-user-blue.svg'" alt="" width="32">
      </a>
    </div>
    <div class="col-6 col-md-2 cont-logo display-vertical-center" (click)="home()">
      <a [routerLink]="[ '/']" id="nav-bar-home-redirect">
        <img [src]="logo || '/assets/svg/logo-farmatodo-blue.svg'" alt="Logo Farmatodo">
      </a>
    </div>

    <div class="col-3 d-block d-md-none center-icons" *ngIf="screenSize?.mobile">
      <div class="cont-cart-noti">
        <div class="cont-cart-noti__icon" aria-label="Notifications">
          <ng-container *ngTemplateOutlet="notificacionContainer"></ng-container>
        </div>
        <div class="cont-cart-noti__icon" aria-label="Cart">
          <app-cart [cart]="cart" [sasCart]="sasCart" [enableSas]="!disableSas"  [icon]="(setHeaderStyle?.active || activeCustom) ? configStylesHeader?.header_cart_icon : null "></app-cart>
        </div>
      </div>
    </div>

    <div class="col country">
      <app-country></app-country>
    </div>


    <div class="col-sm-12 col-md cont-search-navbar">
      <app-algolia-search-box [idPrefix]="'nav-bar-'"></app-algolia-search-box>
    </div>
    <div class="col-12 cont-address-select d-block d-sm-none">
      <app-address-select></app-address-select>
    </div>

    <div class="col-12 d-block d-md-none p-0 m-0"  >
      <div class="open-app" *ngIf="isBrowser && countryConfig.downloadApp && showAppBar">
        <div class="close">
          <app-icons [type]="'close'" (click)="showAppBar = false"></app-icons>
        </div>
        <div class="download">
          <span class="text-download">Descarga gratis la<br>App de Farmatodo</span>
        </div>
        <div class="button-download">
          <a [href]="countryConfig.mobileAppUrl">
            <app-button title="Descargar" customClasses="btn btn-download" sideImg="right" [srcImg]="logoStore">
            </app-button>
          </a>
        </div>
      </div>
    </div>

    <div class="col d-none d-sm-none d-md-block">

      <div class="row cont-items-right mw-450px">
        <div class="col-sm-5 col-md-3 p-0" *ngIf="hasOpenSession">

          <ng-container #profileMenu></ng-container>
          <app-spinner class="cont-user-ok" [default]="true" *ngIf="loadNavBarUser" [isLoading]="loadNavBarUser" [small]="true"></app-spinner>
        </div>

        <ng-container *ngIf="!hasOpenSession">
          <div class="col-sm-5 col-md-3 p-0 login-btn" id="nav-bar-open-login-sign-up"  (click)="openSessionModal()">
            <img class="image customer-icon" [ngClass]="{'ico-christmas': christmas}"  [src]="((setHeaderStyle?.active || activeCustom) && configStylesHeader?.header_user_icon) ? configStylesHeader?.header_user_icon :'/assets/svg/profile.svg'" alt="Profile Icon">
            <span *ngIf="!loadNavBar">Inicia sesión</span>
            <app-spinner [default]="true" [isLoading]="loadNavBar" [small]="true"></app-spinner>
          </div>
        </ng-container>

        <div class="p-0 position-relative nav-bar__location_toltip " *ngIf="!screenSize?.mobile && !hasOpenSession">
          <app-delivery-type [sasCart]="sasCart" [configModule]="configModule" (openSasConfirmation)="onOpenSasConfirmation($event)" app-delivery-type [sasCart]="sasCart" [configModule]="configModule" (openSasConfirmation)="onOpenSasConfirmation($event)" [icon]="( (setHeaderStyle?.active || activeCustom) && configStylesHeader?.header_location_icon) ? configStylesHeader?.header_location_icon : null "></app-delivery-type>
        </div>

        <div id="nav-bar-open-address-modal" class="col-sm-4 col-md-4 p-0" (click)="manageEvent()" *ngIf="hasOpenSession">
          <app-address-user (logOut)="onCallCenterLogOut($event)" [callCenterCustomer]="callCenterCustomer" [icon]="( (setHeaderStyle?.active || activeCustom) && configStylesHeader?.header_location_icon ) ? configStylesHeader?.header_location_icon : null "></app-address-user>
        </div>

        <div class="col-sm-1 col-md-2 p-0 center-icons" *ngIf="showNotificationIcon()">
          <ng-container *ngTemplateOutlet="notificacionContainer"></ng-container>
        </div>

        <div class="col-sm-2 col-md-2 p-0">
          <div class="cont-icon-cart" *ngIf="performanceComponents">
           <img class="icon-cart" alt="Icono de Carrito"  [src]="((setHeaderStyle?.active || activeCustom) && configStylesHeader?.header_cart_icon) ?  configStylesHeader?.header_cart_icon :'./assets/svg/carrito-blue.svg'" >
          </div>
          <app-cart *ngIf="!performanceComponents"  [cart]="cart" [sasCart]="sasCart" [enableSas]="!disableSas" [icon]="(setHeaderStyle?.active || activeCustom) ? configStylesHeader?.header_cart_icon :'./assets/svg/carrito-blue.svg'"></app-cart>
        </div>

      </div>
    </div>
  </div>

  <div class="d-none d-sm-none d-md-block" *ngIf="!screenSize?.mobile">
    <app-header></app-header>
  </div>

  <div id="p2cHomebar" *ngIf="countryConfig.p2c">
    <ng-container #p2cHomebar></ng-container>
  </div>

</header>

<ng-container *ngIf="loadModals && !performanceComponents">
  <app-delivery-type *ngIf="screenSize?.mobile" [sasCart]="sasCart" (openSasConfirmation)="onOpenSasConfirmation($event)"></app-delivery-type>
</ng-container>

<ng-container #sessionModal></ng-container>
<ng-container #notificationsModal></ng-container>
<ng-container #advertisedProducts></ng-container>
<ng-container #customModalVip *ngIf="customer"></ng-container>
<ng-container #policiesModal></ng-container>
<ng-container #creditCardModal *ngIf="customer"></ng-container>
<ng-container #creditCardFormModal *ngIf="customer"></ng-container>
<ng-container #lifeMilesModal *ngIf="customer"></ng-container>
<ng-container #contactsModal></ng-container>
<ng-container #qualifyModal *ngIf="customer"></ng-container>
<ng-container #addressesModal *ngIf="customer"></ng-container>
<ng-container #couponModal *ngIf="customer"></ng-container>
<ng-container #deleteSasCartModal *ngIf="customer"></ng-container>
<ng-container #cancelOrderModal *ngIf="customer"></ng-container>
<ng-container #supportModal></ng-container>
<ng-container #addEditAddressesModal *ngIf="customer"></ng-container>
<ng-container #createPasswordModal></ng-container>
<ng-container #primeNotAvailable></ng-container>
<ng-container #changePasswordComponent *ngIf="customer"></ng-container>
<ng-container #microCharges></ng-container>
<ng-container #itemQuantityAlert></ng-container>
<ng-container #takePillModal></ng-container>
<ng-container #popupModal></ng-container>
<div *ngIf="!disableSasCart">
  <ng-container #sasSidebarCart></ng-container>
  <ng-container #sasProductNotAvailable></ng-container>
</div>

<ng-template #notificacionContainer>
  <app-notification-indicator [notificacionIcon]="this.configStylesHeader?.header_notification_icon" iconSize="2rem">
  </app-notification-indicator>
</ng-template>


